import { FETCH_QUICK_RATES_FAILURE, FETCH_QUICK_RATES_REQUEST, FETCH_QUICK_RATES_RESET, FETCH_QUICK_RATES_SUCCESS, } from "../../actions";
const initialState = {
    quickRates: null,
    isLoading: false,
    error: null,
};
const QuickRateReducer = (state = initialState, action) => {
    var _a;
    switch (action.type) {
        case FETCH_QUICK_RATES_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null, quickRates: null });
        case FETCH_QUICK_RATES_SUCCESS:
            return Object.assign(Object.assign({}, state), { quickRates: action.payload, isLoading: false, error: null });
        case FETCH_QUICK_RATES_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error' });
        case FETCH_QUICK_RATES_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, quickRates: null, error: null });
        default:
            return state;
    }
};
export default QuickRateReducer;
